var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 16C7 15.6958 7.12084 15.4041 7.33593 15.189C7.55103 14.9739 7.84276 14.8531 8.14694 14.8531L21.4362 14.8531L16.512 9.92884C16.3094 9.71142 16.1991 9.42385 16.2043 9.12671C16.2096 8.82957 16.33 8.54607 16.5401 8.33593C16.7502 8.12579 17.0337 8.00542 17.3309 8.00018C17.628 7.99494 17.9156 8.10523 18.133 8.30783L25.0147 15.1895C25.2295 15.4045 25.3501 15.6961 25.3501 16C25.3501 16.3039 25.2295 16.5955 25.0147 16.8105L18.133 23.6922C17.9156 23.8948 17.628 24.0051 17.3309 23.9998C17.0337 23.9946 16.7502 23.8742 16.5401 23.6641C16.33 23.4539 16.2096 23.1704 16.2043 22.8733C16.1991 22.5761 16.3094 22.2886 16.512 22.0712L21.4362 17.1469L8.14694 17.1469C7.84276 17.1469 7.55103 17.0261 7.33593 16.811C7.12084 16.5959 7 16.3042 7 16Z",
    fill: "#161616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.27642aca6bc494302e4b39b17894f287.svg";
export { ForwardRef as ReactComponent };